import {Component, OnInit} from '@angular/core';
import {DomSanitizer, SafeStyle} from '@angular/platform-browser';
import {UpdaterService} from '../../services/updater/updater.service';

/**
 * Angular default mappings
 */
@Component({
  selector: 'app-updater',
  templateUrl: './updater.component.html',
  styleUrls: ['./updater.component.scss']
})
export class UpdaterComponent implements OnInit {

  /**
   * The styling used for the width of the progress bar
   */
  progressStyle: SafeStyle;

  /**
   * Default ctor
   * @param updaterService provided by DI
   * @param san provided by DI
   */
  constructor(public updaterService: UpdaterService,
              public san: DomSanitizer) {
    this.updaterService = updaterService;
    this.san = san;
    this.updaterService.progressEvent.subscribe(() => {
      this.progressStyle = san.bypassSecurityTrustStyle('width: ' + updaterService.percent + '%;');
    });
  }

  /**
   * Default initialization
   */
  ngOnInit() {
  }

}
